<template>
  <div class="tracking-networks">
    <router-view/>

    <layout-logged-frame :title="$t('networks')">
      <template #header-actions>
        <v-btn
          color="primary"
          @click="openNewNetworkModal"
        >
          <v-icon>add</v-icon>
          {{ $t('new_network') }}
        </v-btn>
      </template>

      <template #content>
        <NetworkFilters @filter="onFilter" @clearFilters="onClearFilters" id="network-filters"/>
        <table-base
          :columns="columns"
          :items="networks"
          :pages="totalPages"
          :pagination="pagination"
          :is-loading="isLoading"
          has-custom-items-template
          :on-select-item="selectNetwork"
          :on-update-pagination="onUpdatePagination"
          :on-change-page="onChangePage"
        >
          <template #item-cell="scope">
            <template v-if="scope.cell.column.value === 'platforms'">
              <div class="d-flex flex-wrap gap-6">
                <PlatformPanel
                  v-for="platform in scope.cell.item.platforms"
                  :key="platform.code"
                  :country="platform"
                />
              </div>
            </template>

            <template v-else>
              {{ displayColumnValue(scope.cell.item, scope.cell.column.value) }}
            </template>
          </template>
        </table-base>
      </template>
    </layout-logged-frame>
  </div>
</template>

<script>
  import { extractNestedProp, isStr } from '../../utils';
  import columns from '../../config/tracking/columnsNetworks';
  import PlatformPanel from '@/components/panels/Platform.vue';
  import NetworkFilters from '@/components/forms/filters/TrackingNetworks.vue';

  export default {
    components: {
      PlatformPanel,
      NetworkFilters,
    },
    data() {
      return {
        columns,
        pagination: {
          order: 'desc',
          page: 1,
          rowsPerPage: 30,
          sortBy: 'created_at',
          totalItems: 0,
        },
        totalPages: 0,
        query: {},
        isLoading: false,
      };
    },
    computed: {
      networks() {
        return this.$store.getters['tracking/trafficNetworks'];
      },
      currentRoute() {
        return this.$route;
      },
    },
    watch: {
      currentRoute(to, from) {
        if (
          from.name === 'tracking-networks-new' &&
          to.name === 'tracking-networks' &&
          to.query?.status === 'success'
        ) {
          this.getNetworks(this.query);
        }
      },
    },
    methods: {
      async getNetworks(query = {}) {
        this.isLoading = true;
        query.per_page = this.pagination.rowsPerPage;

        return this.$store
          .dispatch('tracking/getTrafficNetworks', query)
          .then((res) => {
            const { meta } = res;
            if (meta) {
              const { total, current_page, last_page } = meta;
              this.pagination.page = current_page;
              this.pagination.totalItems = total;
              this.totalPages = last_page;
            }

            return res;
          })
          .catch((err) => err)
          .finally(() => {
            this.isLoading = false;
          });
      },
      onUpdatePagination({ page, order, sortBy }) {
        const { query } = this;
        this.pagination.order = order;
        this.pagination.sortBy = isStr(sortBy) ? sortBy : pagination.sortBy;
        const resolvedSort = isStr(sortBy) ? sortBy : null;
        const nextQuery = {
          ...query,
          page,
          ...(resolvedSort ? { sort: resolvedSort, order } : {}),
        };

        this.query = nextQuery;
        this.getNetworks(nextQuery);
      },
      onFilter(filters) {
        this.query = {
          ...this.query,
          page: 1,
          ...filters,
        };
        this.getNetworks(this.query);
      },
      onClearFilters() {
        this.query = {};
        this.getNetworks(this.query);
      },
      selectNetwork(network) {
        this.$store.dispatch('tracking/setActiveTrafficNetwork', network);
        this.$router.push({ name: 'tracking-networks-detail', params: { id: network.id } });
      },
      openNewNetworkModal() {
        this.$router.push({ name: 'tracking-networks-new' });
      },
      onChangePage(page) {
        const { query, pagination } = this;
        const { order, sortBy } = pagination;
        const nextQuery = {
          ...query,
          page,
          ...(sortBy ? { sort: sortBy, order } : {}),
        };

        this.query = nextQuery;
        this.getNetworks(nextQuery);
      },
      displayColumnValue(item, columnValue) {
        return extractNestedProp(item, columnValue);
      },
    },
  };
</script>

<style lang="scss">
</style>
